import { render, staticRenderFns } from "./disabled-editor.vue?vue&type=template&id=481194aa&scoped=true&"
import script from "./disabled-editor.vue?vue&type=script&lang=js&"
export * from "./disabled-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481194aa",
  null
  
)

export default component.exports